import { Div, Label } from '@vgrubs/components';
import styled from 'styled-components';
import PhoneInput from 'react-phone-number-input';

export const PhoneInputStyled = styled.div<{ $textCenter: boolean }>`
  border: 1px solid ${({ theme }) => theme.darkGray}80;
  background: none;
  border-radius: 200px;
  padding: 0 20px;
  height: ${({ theme }) => theme.input.height};
  display: flex;
  align-items: center;
  width: 100%;

  input {
    font-size: ${({ theme }) => theme.input.fontSize};
    margin-left: 24px;
    width: 100%;
    border: none;
    background: none;
    :focus {
      outline: none;
    }
    ${({ $textCenter }) => {
    return (
      $textCenter &&
      `
      text-align: center;
      margin-right: 24px;
    `
    );
  }}
  }

  position: relative;

  .PhoneInput {
    width: 100% !important;
  }

  .PhoneInputCountry {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translate(0, -50%);

    select {
      height: 35px;
    }

    .PhoneInputCountryIcon {
      height: 27px;
      width: 27px;

      border-radius: 50%;
      overflow: hidden;

      img {
        object-fit: cover;
      }

      border: none;
      box-shadow: none;
      background-color: none;
    }
    .PhoneInputCountrySelectArrow {
      display: none;
    }
  }

  @media (max-width: 800px) {
    font-size: ${({ theme }) => theme.input.fontSize};

    .PhoneInputCountry {
      left: 8px;
    }
  }

  :focus-visible {
    outline: ${({ theme }) => theme.primary} 1px;
  }
`;

export const AdminPhoneInput = ({
  label,
  $textCenter,
  maxWidth,
  maxWidthSM,
  ...props
}: {
  label?: string;
  $textCenter?: boolean;
  maxWidth?: string;
  maxWidthSM?: string;
  value: string;
  onChange: (value: string) => void;
}) => {
  return (
    <Div $relative $width="100%" $maxWidth={maxWidth} $maxWidthSM={maxWidthSM}>
      {label && <Label label={label} $textCenter={$textCenter} />}

      <PhoneInputStyled $textCenter={!!$textCenter}>
        <PhoneInput
          placeholder="Enter here..."
          defaultCountry="US"
          addInternationalOption={false}
          international
          focusInputOnCountrySelection={true}
          {...(props as any)}
          value={props.value as string}
          onChange={(value) => props.onChange(value as string)}
        />
      </PhoneInputStyled>
    </Div>
  );
};
